import {UPDATE_USERNAME, USER_SET} from "../constants/ActionTypes";
import {fetchGamesByUser} from "../actions";


const INITIAL_STATE = {
    user: null
};

export default function userReducer(state = INITIAL_STATE, action) {

    switch(action.type) {
        // here, the payload is the firebase document ref.
        case USER_SET : {

            const doc = action.payload;
            if (!doc || !doc.exists) {
                return { ...state, user: null };
            } else {
                const user = doc.data();
                user.id = doc.id;
                fetchGamesByUser(user);
                return { ...state, user };
            }
        }

        // here, the payload is the username.
        case UPDATE_USERNAME : {
            if (!!state.user) {
                return { user: { ...state.user, name: action.payload.name }}
            } else {
                return { user: { name: action.payload.name, id: action.payload.id } };
            }
        }
        default : return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js